import CustomStore from 'devextreme/data/custom_store';
import EventBus from '@/services/event-bus';
import Api from '../../../services/Api';
import { applySamplesExportPagination } from '@/utils/samplesExport';

let lastAgronomySamplesReq = null;
let lastAgronomySamplesWithFiltersReq = null;
let lastAgronomySampleDetailsReq = null;

export default {
  namespaced: true,
  state: {
    allSamples: [],
    sampleDetails: null,
  },
  actions: {
    async getSamples({ rootState }, params) {
      try {
        if (lastAgronomySamplesReq && lastAgronomySamplesReq.abort) {
          lastAgronomySamplesReq.abort();
        }

        lastAgronomySamplesReq = Api.getAgronomySamples(
          params,
          rootState.contact.company,
          rootState.contact.address
        );

        const xhr = await lastAgronomySamplesReq;
        const response = JSON.parse(xhr.response);

        return Promise.resolve({
          data: response.data,
          totalCount: response.totalCount,
        });
      } catch (error) {
        if (error && error.message === 'abort') {
          return Promise.resolve({ data: [], totalCount: 0 });
        }
        return Promise.reject(error);
      }
    },
    async getSamplesWithFilters({ rootState }, params) {
      try {
        if (
          lastAgronomySamplesWithFiltersReq &&
          lastAgronomySamplesWithFiltersReq.abort
        ) {
          lastAgronomySamplesWithFiltersReq.abort();
        }

        lastAgronomySamplesWithFiltersReq = Api.getAgronomySamplesWithFilters(
          params,
          rootState.contact.company,
          rootState.contact.address
        );

        const xhr = await lastAgronomySamplesWithFiltersReq;
        const response = JSON.parse(xhr.response);

        return Promise.resolve({
          data: response.data,
          totalCount: response.totalCount,
        });
      } catch (error) {
        if (error && error.message === 'abort') {
          return Promise.resolve({ data: [], totalCount: 0 });
        }
        return Promise.reject(error);
      }
    },
    async getSampleDetails({ commit, rootState }, id) {
      try {
        if (lastAgronomySampleDetailsReq && lastAgronomySampleDetailsReq.abort) {
          lastAgronomySampleDetailsReq.abort();
        }

        lastAgronomySampleDetailsReq = Api.getSampleDetails(
          id,
          null,
          rootState.filter.currentFilter,
          rootState.contact.company,
          rootState.contact.address
        );
        const xhr = await lastAgronomySampleDetailsReq;
        const response = JSON.parse(xhr.response);

        commit('setSampleDetails', response.data);
        return Promise.resolve();
      } catch (error) {
        if (error && error.message === 'abort') {
          return Promise.resolve();
        }
        return Promise.reject(error);
      }
    },
    async getStudySatellite({ rootState }, params = null) {
      try {
        const xhr = await Api.getStudySatellite(
          rootState.contact.company,
          rootState.contact.address,
          params
        );
        const response = JSON.parse(xhr.response);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getStoreWithFilters({ rootState, dispatch }, paramFilters) {
      return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
          let params = '?';
          let sortSettings = [];
          ['skip', 'take', 'sort'].forEach((i) => {
            if (i in loadOptions) {
              if (i === 'sort' && loadOptions[i] !== null) {
                sortSettings = loadOptions[i];
              } else {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              }
            }
          });

          params = params.slice(0, -1);

          if (params.includes('skip')) {
            let subsistuteParams = params.replace('skip', 'offset');

            subsistuteParams = subsistuteParams.replace(
              'take',
              'limit'
            );

            const offsetLimit = subsistuteParams.split('&');

            const offset = offsetLimit[0].split('=')[1];

            const limit = offsetLimit[1].split('=')[1];
            paramFilters.offset = offset;
            paramFilters.limit = limit;
          } else {
            paramFilters.limit = null;
            paramFilters.offset = null;
          }

          const sortParams = await dispatch(
            'filter/applySort',
            {
              sortSettings,
              isFilter: true,
            },
            { root: true }
          );

          if (loadOptions.filter) {
            if (loadOptions.filter[0]) {
              paramFilters.filter_search =
                loadOptions.filter[0].filterValue;
            }
          } else {
            paramFilters.filter_search = null;
          }

          paramFilters.ordering = sortParams.sort;
          const requestFilters =
            loadOptions.isLoadingAll === true
              ? { ...paramFilters, offset: 0, limit: 250 }
              : paramFilters;
          return dispatch('getSamplesWithFilters', requestFilters);
        },
      });
    },
    callStoreWithFilters({ commit }, params) {
      EventBus.$emit('AgronomySamplesPage', params);
    },
    setFilteredSamples({ commit }, value) {
      EventBus.$emit('AgronomySamplesPage', null);
    },
    setSamples({ commit }, value) {
      commit('setSamples', value);
    },
    setSampleDetails({ commit }, value) {
      commit('setSampleDetails', value);
    },
    getStore({ dispatch, rootState }) {
      return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
          let params = '?';
          let sortSettings = [
            { selector: 'sampling_date', desc: true },
          ];

          ['skip', 'take', 'sort'].forEach((i) => {
            if (i in loadOptions) {
              if (i === 'sort' && loadOptions[i] !== null) {
                sortSettings = loadOptions[i];
              } else {
                params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              }
            }
          });

          params = params.slice(0, -1);
          let subsistuteParams = params.replace('skip', 'offset');
          subsistuteParams = subsistuteParams.replace(
            'take',
            'limit'
          );

          const sortParams = await dispatch(
            'filter/applySort',
            {
              sortSettings,
              isFilter: false,
            },
            { root: true }
          );

          subsistuteParams += sortParams;

          if (!subsistuteParams.startsWith('?')) {
            subsistuteParams = `?${subsistuteParams}`;
          }
          if (loadOptions.filter) {
            if (loadOptions.filter[0]) {
              subsistuteParams += `&filter_search=${loadOptions.filter[0].filterValue}`;
            }
          }
          return dispatch(
            'getSamples',
            applySamplesExportPagination(subsistuteParams, loadOptions)
          );
        },
      });
    },
  },
  mutations: {
    setSamples(state, value) {
      state.allSamples = value;
    },
    setSampleDetails(state, value) {
      state.sampleDetails = value;
    },
  },
};
